
import React from 'react';
import { Provider } from 'react-redux';
import store from '@@/store';
import ReactDOM from 'react-dom';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import styled from 'styled-components';
import UploadItem from './_components/UploadItem';
import { Icon,Modal,Form,Input,Radio,Upload, Button,notification,message } from 'antd';
import { Root } from './style';
import Api from '@/services';
import { judgeArr } from '@/shared/functions';
import { consoleSandbox } from '@sentry/utils';


const mapStateToProps = (rootState, ownProps) => ({
  _state: rootState.transfer
});
function beforeUpload(file) {
  const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error('上传的图片不超过5MB');
    }
    return isLt5M;
}

class AddPicture extends React.Component {

  constructor(props){
    super(props)
    this.state={
      visible: true,
      count: 0,
      waitValue: 0,
      num: 0,
      hideModal: false,
      initData: this.props._state.getUploadPicData,
      commonTransferType: this.props._state.commonTransferType
    }
    this.handleCancel = this.handleCancel.bind(this);
    this.confirmOk = this.confirmOk.bind(this);
  }
  
 //上传图片
  upload = (url,file,index,key,required) =>{
    let {initData,commonTransferType} = this.state;
    const { waitValue } = this.props
    let targetIndex = initData.modelGroup.findIndex(el=>el.typeName===key);
    if(beforeUpload(file)){
      const formData = new FormData();
      formData.append('file', file);
      formData.append('picName', 'file');
      Api.order.uploadImage(formData).then((res) => {
        initData.modelGroup[targetIndex].picGroup.push({
          url: res,
          // status: 1,
          // file: file
        })
        this.setState({
          initData,
        })
      })
    }
  }
  //删除图片
  delItem = (typeName,index)=>{
      let {initData} = this.state;
      let targetIndex = initData.modelGroup.findIndex(el=>el.typeName===typeName);
      initData.modelGroup[targetIndex].picGroup.splice(index,1);
      this.setState({
          initData
      })
  }
  confirmOk(){
    const {initData} = this.state
    dispatch.transfer.updateData(initData)
  }

  handleCancel(){
    const {initData} = this.state
    dispatch.transfer.HIDE_ADD_MODAL();
    initData.modelGroup.map((item,index)=>{
      item.picGroup.length = 0;
    })
    dispatch.transfer.SET_STATE({
      forbiddenButton: false,
      picCount:0
    })
  }

  uploadImg(typeName,soureData,count,desc,required,upload,delItem,picTransferType,key,keyValue){
    return (
      <UploadItem 
        typeName={typeName}
        soureData={soureData}
        count={count}
        desc={desc}
        required={required}
        upload={upload}
        delItem={delItem}
        picTransferType = {picTransferType}
        key = {key}
        keyValue = {keyValue}>
      </UploadItem>
     )
  }

  uploadItem(getUploadPicData,transferType,waitValue){
    if(transferType==30&&waitValue==10){
      return getUploadPicData.modelGroup.map((item,index)=>{
        if(item.picTransferType==0||item.picTransferType==10){
          return this.uploadImg(item.typeName,item.picGroup,item.count,item.desc,item.lRequired,
            this.upload,this.delItem,item.picTransferType,index,index
          )
        }
      })
    }
    if(transferType==30&&waitValue==20){
      return getUploadPicData.modelGroup.map((item,index)=>{
        if(item.picTransferType==0||item.picTransferType==20){
          return this.uploadImg(item.typeName,item.picGroup,item.count,item.desc,item.eRequired,
            this.upload,this.delItem,item.picTransferType,index,index
          )
        }
      })
    }
    else{
      return getUploadPicData.modelGroup.map((item,index)=>{
        return this.uploadImg(item.typeName,item.picGroup,item.count,item.desc,(transferType==10)?item.lRequired:item.eRequired,
          this.upload,this.delItem,item.picTransferType,index,index
        )
      })
    }
  }

  render() {
    const {getUploadPicData, elasticFrameVisibles } = this.props._state;
    let transferType = getUploadPicData.transferType
    const { waitValue } = this.props
    const { initData } = this.state;
    const {num} = this.props._state;
    return(
        <Modal
          title='添加过户信息'
          visible={elasticFrameVisibles}
          width = {1018}
          maskClosable = {false}
          afterClose={this.afterClose}
          onOk={this.confirmOk}
          onCancel={this.handleCancel}
          okText = '保存'
          cancelText="取消"
        >
        <Form>
          <Root>
            {this.uploadItem(initData,transferType,waitValue)}
        </Root>
      </Form>
    </Modal>
    )
  }
}
const AddPictures = Form.create({})(AddPicture);
const AddTransferInfo = connect(mapStateToProps)(AddPictures);
export default AddTransferInfo;
